import React from "react";
import "./Privacy.scss";

const Privacy = () => {
  return (
    <section className="privacy-page-container">
      <div className="privacy-card">
        {/* Header Utama */}
        <h1 className="privacy-title">Kebijakan Privasi</h1>
        <p className="privacy-subtitle">Terakhir diperbarui: Juli 2026</p>

        <div className="privacy-divider"></div>

        {/* Content Points */}
        <div className="privacy-content">
          <div className="privacy-section-item">
            <h3 className="section-heading">Informasi yang Kami Kumpulkan</h3>
            <p className="section-text">
              Kami mengumpulkan informasi yang Anda berikan secara sukarela
              melalui form kontak atau WhatsApp, termasuk nama, nomor telepon,
              dan alamat email.
            </p>
          </div>

          <div className="privacy-section-item">
            <h3 className="section-heading">Penggunaan Informasi</h3>
            <p className="section-text">
              Informasi Anda digunakan untuk menghubungi Anda terkait properti
              yang Anda minati, mengirimkan informasi promo, dan meningkatkan
              layanan kami.
            </p>
          </div>

          <div className="privacy-section-item">
            <h3 className="section-heading">Perlindungan Data</h3>
            <p className="section-text">
              Kami menjaga keamanan data Anda dan tidak akan membagikan
              informasi pribadi Anda kepada pihak ketiga tanpa persetujuan Anda,
              kecuali diwajibkan oleh hukum.
            </p>
          </div>

          <div className="privacy-section-item">
            <h3 className="section-heading">Kontak</h3>
            <p className="section-text">
              Jika ada pertanyaan mengenai kebijakan ini, hubungi kami melalui
              WhatsApp:{" "}
              <a
                href="https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="wa-link">
                +6281188083575
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
